import { Link, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '@/components/ui/button';
import { Menu, X, User as UserIcon } from 'lucide-react';
import { useState } from 'react';

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background font-sans text-foreground flex flex-col">
      <header className="sticky top-0 z-50 w-full border-b border-white/20 bg-white/70 dark:bg-black/60 backdrop-blur-xl">
        <div className="container mx-auto px-4 h-16 flex items-center justify-between">
          <Link to="/" className="text-2xl font-bold font-heading text-primary tracking-tight">
            Tanducibless<span className="text-secondary">.</span>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-6">
            <Link to="/" className="text-sm font-medium hover:text-primary transition-colors">Inicio</Link>
            {user ? (
              <>
                <Link to="/dashboard" className="text-sm font-medium hover:text-primary transition-colors">Dashboard</Link>
                {user.role === 'admin' && (
                  <Link to="/admin/audit" data-testid="nav-audit-link" className="text-sm font-medium hover:text-primary transition-colors">Auditoría</Link>
                )}
                <Link to="/profile" className="flex items-center gap-2 text-sm text-muted-foreground bg-secondary/20 px-3 py-1 rounded-full hover:bg-secondary/30 transition-colors">
                    <UserIcon className="w-4 h-4" />
                    <span>{user.full_name}</span>
                </Link>
                <Button variant="ghost" onClick={() => { logout(); navigate('/'); }}>
                  Salir
                </Button>
              </>
            ) : (
              <>
                <Link to="/login">
                  <Button variant="ghost">Entrar</Button>
                </Link>
                <Link to="/signup">
                  <Button className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-full">
                    Registrarse
                  </Button>
                </Link>
              </>
            )}
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            {isMenuOpen ? <X /> : <Menu />}
          </button>
        </div>

        {/* Mobile Nav */}
        {isMenuOpen && (
          <div className="md:hidden p-4 bg-background border-b border-border space-y-4">
            <Link to="/" className="block text-sm font-medium" onClick={() => setIsMenuOpen(false)}>Inicio</Link>
            {user ? (
              <>
                <Link to="/dashboard" className="block text-sm font-medium" onClick={() => setIsMenuOpen(false)}>Dashboard</Link>
                {user.role === 'admin' && (
                  <Link to="/admin/audit" className="block text-sm font-medium" onClick={() => setIsMenuOpen(false)}>Auditoría</Link>
                )}
                 <Link to="/profile" className="block text-sm font-medium" onClick={() => setIsMenuOpen(false)}>Mi Perfil</Link>
                <button onClick={() => { logout(); setIsMenuOpen(false); navigate('/'); }} className="block text-sm font-medium text-destructive">
                  Cerrar Sesión
                </button>
              </>
            ) : (
              <>
                <Link to="/login" className="block text-sm font-medium" onClick={() => setIsMenuOpen(false)}>Entrar</Link>
                <Link to="/signup" className="block text-sm font-medium text-primary" onClick={() => setIsMenuOpen(false)}>Registrarse</Link>
              </>
            )}
          </div>
        )}
      </header>

      <main className="flex-1 container mx-auto px-4 py-8">
        <Outlet />
      </main>

      <footer className="border-t border-border py-8 bg-muted/30">
        <div className="container mx-auto px-4 text-center text-sm text-muted-foreground">
          <p>© 2025 Tanducibless por ATLASST. Hecho con 🏳️‍⚧️ orgullo.</p>
        </div>
      </footer>
    </div>
  );
}
